/**
 * BUILDERS' WORDS ↔ THE PLATFORM'S TYPE NAMES — the entity chat's vocabulary table.
 * Platform spelling only (`STRING`, `TIMESTAMP`): that is what entity records store. The Atlas map's
 * Blockly spelling (`String`, `TimeStamp`) is never read here (spec, "Type vocabulary").
 * One row per type the form offers, in the form's order — pinned against OFFERED_FIELD_TYPES.
 */
export interface TypeWords {
  type: string;
  /** How the chat names the type to a builder. */
  label: string;
  /** Words a builder uses for it — fed to the prompt. */
  words: string[];
}

export const FIELD_TYPE_VOCABULARY: readonly TypeWords[] = [
  { type: 'STRING', label: 'Text', words: ['text', 'name', 'email', 'phone', 'address', 'note', 'code'] },
  { type: 'NUMBER', label: 'Number', words: ['number', 'amount', 'price', 'money', 'quantity', 'count', 'total'] },
  { type: 'BOOLEAN', label: 'Yes/No', words: ['yes/no', 'true/false', 'flag', 'checkbox', 'is …', 'has …'] },
  { type: 'ARRAY_OF_OBJECT', label: 'List of items', words: ['list of', 'line items', 'items', 'entries, each with'] },
  { type: 'ENTITY_REFERENCE', label: 'Link to another entity', words: ['link to', 'belongs to', 'refers to', 'for a …'] },
  { type: 'ATTACHMENT', label: 'File', words: ['file', 'attachment', 'image', 'photo', 'document', 'upload'] },
  { type: 'TIMESTAMP', label: 'Date and time', words: ['date', 'time', 'when', 'deadline', 'created on'] },
  { type: 'GEOMETRY', label: 'Map shape', words: ['area on a map', 'boundary', 'region', 'map shape'] },
];

/** A type in builders' words; an unknown or system type passes through as its platform name. */
export function typeLabel(type: string): string {
  return FIELD_TYPE_VOCABULARY.find((v) => v.type === type)?.label ?? type;
}
